module.exports = __webpack_public_path__ + "static/media/img-horizontal-ealry-leave.bd72a788.png";